/* src/app/ui/sidebar/sidebar.component.scss */
.sidebar-wrapper {
  height: 100%;
}
.sidebar-wrapper .logo {
  margin: 1rem 0 1.5rem 2rem;
  height: 3rem;
  width: 6.3125rem;
}
.sidebar-wrapper .list-group .list-group-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0;
  border-left: 0.25rem solid transparent;
  background: transparent;
}
.sidebar-wrapper .list-group .list-group-item .list-item {
  width: 100%;
  text-decoration: none;
  padding: 0.75rem 2rem;
}
.sidebar-wrapper .list-group .list-group-item .title,
.sidebar-wrapper .list-group .list-group-item .title-fav {
  font-size: 1rem;
  line-height: 1.75rem;
  font-weight: 300;
  color: #ffffff;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
}
.sidebar-wrapper .list-group .list-group-item .title-fav {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
}
.sidebar-wrapper .list-group .list-group-item.active-route {
  border-left: 0.25rem solid #ffe600;
  background-color: rgba(255, 255, 255, 0.08);
  text-decoration: none;
}
.sidebar-wrapper .list-group .list-group-item.active-route .title {
  color: #ffe600;
  font-size: 1rem;
  line-height: 1.75rem;
  font-weight: 400;
}
.sidebar-wrapper .list-group .list-group-item.list-sub-menu.active-route {
  border-left: 0.25rem solid #ffe600;
}
.sidebar-wrapper .list-group .list-group-item.list-sub-menu.active-route .title {
  color: #ffffff;
}
.sidebar-wrapper .list-group .list-group-item.list-sub-menu.active-route.active-link .title {
  color: #ffe600;
}
.sidebar-wrapper .list-group .list-group-item.active-sub-route .title-fav {
  color: #ffe600;
}
.sidebar-wrapper .list-group .list-group-item .fav-icon {
  font-size: 1.25rem;
  line-height: 1.25rem;
  color: rgba(255, 255, 255, 0.64);
  margin-left: 0.3125rem;
}
.sidebar-wrapper .list-group.list-group-sub-menu .list-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.icon {
  margin-right: 1rem;
}
/*# sourceMappingURL=sidebar.component.css.map */
